import { COLORS } from 'modules/core/theme/colors';
import styled, { keyframes } from 'styled-components';

export const spin = keyframes`
  0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
  25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
  50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
  75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
  100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
`;

export const Spiner = styled.i`
  width: 18px;
  height: 18px;
  border: 2px solid gray;
  border-radius: 50% !important;
  position: absolute;
  transform: rotate(45deg);
  box-sizing: border-box;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    box-sizing: border-box;
    inset: -2px;
    border-radius: 50%;
    border: 2px solid ${COLORS.BLUE_12};
    animation: ${spin} 1.5s infinite linear;
  }
`;
